import React from "react";
import PropTypes from "prop-types";
import { Box, Chip, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { bondTypes } from "../hooks/useApproveBonds";

export default function ApproveBondsBondTypeToggle({
  selectedType,
  handleBondTypeClick,
  toBeCancelledBonds,
  activeCounts,
}) {
  return (
    <Box sx={{ mt: 2 }}>
      <ToggleButtonGroup
        value={selectedType}
        exclusive
        onChange={(_, v) => v && handleBondTypeClick(v)}
        sx={{
          flexWrap: "wrap",
          gap: 1,
          "& .MuiToggleButton-root": {
            borderRadius: "999px !important",
            px: 2,
            py: 0.75,
            border: "1px solid",
            borderColor: "divider",
          },
        }}
      >
        {bondTypes.map((type) => {
          const toCancelCount = toBeCancelledBonds.filter((b) => b.bond_type === type).length;
          const activeOnly = Math.max((activeCounts[type] || 0) - toCancelCount, 0);
          return (
            <ToggleButton key={type} value={type}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                  {type}
                </Typography>
                {activeOnly > 0 && <Chip size="small" color="primary" label={activeOnly} />}
                {toCancelCount > 0 && <Chip size="small" color="error" label={toCancelCount} />}
              </Stack>
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </Box>
  );
}

ApproveBondsBondTypeToggle.propTypes = {
  selectedType: PropTypes.string.isRequired,
  handleBondTypeClick: PropTypes.func.isRequired,
  toBeCancelledBonds: PropTypes.array.isRequired,
  activeCounts: PropTypes.object.isRequired,
};
